// Utility to fetch the home title from 00-Home.json
export async function getHomeTitle(language = 'en') {
  try {
    const resp = await fetch('/descriptions/00-Home.json');
    const data = await resp.json();
    // data could be an array or an object
    const item = Array.isArray(data) ? data[0] : data;
    return item?.title?.[language] || item?.title?.en || 'Armonia House';
  } catch {
    return 'Armonia House';
  }
}
